import React from "react";
import Moment from "react-moment";
import { Box, Grid, Typography } from "@mui/material";
import { stringFormate } from "src/common/utils/helpers";

interface Props {
  field: string;
  value: any;
  isDateField?: boolean;
  asHtml?: boolean;
}

export const CardItem = ({ field, value, isDateField = false, asHtml }: Props) => {
  const changesTo = () => {
    if (asHtml) {
      return <Typography style={{ wordWrap: "break-word" }}>{stringFormate(value)}</Typography>;
    } else {
      return (
        <Typography>
          <Moment local={true} format="MM/DD/YYYY hh:mm A" date={value} />
        </Typography>
      );
    }
  };
  return (
    <Grid container item direction="row" xs={6} md={asHtml ? 10 : 4}>
      <Grid item xs={asHtml ? 2 : 5}>
        <Box color="text.secondary">
          <Typography>{`${field}: `}</Typography>
        </Box>
      </Grid>
      <Grid item xs={asHtml ? 10 : 7}>
        <Box color="text.primary">
          {(isDateField || asHtml) && Boolean(value) ? (
            changesTo()
          ) : (
            <Typography>{value}</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
